
import { useState } from "react";
import { 
  Card, 
  CardContent, 
  CardDescription, 
  CardHeader, 
  CardTitle 
} from "@/components/ui/card";
import { SecurityLogsTable } from "./security-logs/SecurityLogsTable";
import { SecurityLogsFilter } from "./security-logs/SecurityLogsFilter";
import { useSecurityLogs } from "@/hooks/useSecurityLogs";

const SecurityLogsTab = () => {
  const [filters, setFilters] = useState({
    actionType: "",
    userId: "",
    dateFrom: undefined as Date | undefined,
    dateTo: undefined as Date | undefined
  });

  const { logs, isLoading } = useSecurityLogs(filters);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Logs de Segurança</CardTitle>
        <CardDescription>
          Monitore ações críticas de segurança no sistema
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <SecurityLogsFilter filters={filters} setFilters={setFilters} />
        <SecurityLogsTable logs={logs} isLoading={isLoading} />
      </CardContent>
    </Card>
  );
};

export default SecurityLogsTab;
